import { SpareCarrier } from "@/pages/rollshop/models/SpareCarrier";
import { upsertScheduleCampaignStands } from "@/pages/rollshop/repositories/SparesRepository";
import { ErrorModal } from "@dexteel/mesf-core";
import CommentIcon from "@mui/icons-material/Comment";
import { Grid2, IconButton, Popover, TextField } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { MouseEvent as ReactMouseEvent, useState } from "react";

export const CommentsColumn = ({
	carrier,
	setNotificationMessage,
}: {
	carrier: SpareCarrier;
	setNotificationMessage: (message: string) => void;
}) => {
	const color = carrier.Comments ? "green" : "";

	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [comment, setComment] = useState<string>(carrier.Comments);
	const [error, setError] = useState<string>("");

	const queryClient = useQueryClient();
	const upsertMutation = useMutation(upsertScheduleCampaignStands, {
		onSuccess: async () => {
			await queryClient.invalidateQueries(["readyCarriers"]);
			setNotificationMessage("Comment saved successfully");
		},
		onError: (error: Error) => {
			setError(error.message);
		},
	});
	const handleClick = (event: ReactMouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
		if (comment !== carrier.Comments) {
			upsertMutation.mutate({
				campaignId: carrier.CampaignId,
				standId: carrier.StandId,
				comments: comment,
			});
		}
	};

	return (
		<>
			<Grid2
				container
				spacing={1}
				className={`buttons`}
				sx={{
					alignItems: "center",
					opacity: 0,
					transition: "opacity 0.1s ease-in-out",
				}}
			>
				<Grid2 size={{ md: 12, xs: 12 }}>
					<IconButton
						onClick={handleClick}
						style={{
							textDecoration: "none",
							fontWeight: 500,
							fontSize: "0.75rem",
							borderRadius: "3px",
							marginRight: 8,
							color,
						}}
					>
						<CommentIcon />
					</IconButton>
				</Grid2>
			</Grid2>
			<Popover
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				<TextField
					multiline
					minRows={6}
					variant="outlined"
					fullWidth
					placeholder="Enter the comments here"
					onChange={(e) => setComment(e.target.value)}
					value={comment}
					style={{ width: "500px" }}
				/>
			</Popover>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
